// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"7679":"46b97596","8388":"2fbf9dd2"}[chunkId] + "." + {"7679":"d24e3756f72fc60d","8388":"37cae006d05c472a"}[chunkId] + ".js";
};